import { Toaster as SonnerToaster } from 'sonner';

/**
 * Toaster unificado — usa Sonner exclusivamente.
 * Estilizado para combinar com o design system:
 *   - Posição bottom-right (menos intrusivo)
 *   - rounded-xl + border + sombra card
 *   - Z-index z-toast (500) via CSS var
 */
export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group font-sans text-sm rounded-xl border border-border shadow-card-md bg-background text-foreground',
          title: 'font-semibold',
          description: 'text-muted-foreground',
          actionButton: 'bg-primary text-primary-foreground rounded-md px-3 py-1.5 text-xs font-medium cursor-pointer',
          cancelButton: 'bg-muted text-muted-foreground rounded-md px-3 py-1.5 text-xs font-medium cursor-pointer',
          closeButton: 'text-muted-foreground hover:text-foreground',
          success: 'border-emerald-200 bg-emerald-50 text-emerald-900 dark:border-emerald-800 dark:bg-emerald-950 dark:text-emerald-100',
          error: 'border-red-200 bg-red-50 text-red-900 dark:border-red-800 dark:bg-red-950 dark:text-red-100',
          warning: 'border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-100',
          info: 'border-blue-200 bg-blue-50 text-blue-900 dark:border-blue-800 dark:bg-blue-950 dark:text-blue-100',
        },
      }}
    />
  );
}
